import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "stores/auth";

import { RATE_TYPE_LABELS } from "types/rate";

const Rates = ({ client }) => {
  const { t } = useTranslation();
  const authStore = useContext(AuthContext);
  const user = authStore.user;

  return (
    <>
      <section aria-labelledby="client-overview-title">
        <div className="rounded-lg bg-white overflow-hidden shadow">
          <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
            <div className="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
              <div className="ml-4 mt-2 w-full flex justify-between">
                <div>
                  <h3 className="text-xl leading-6 font-medium text-gray-800">
                    {t("Services and Rates")}
                  </h3>
                </div>
                <div>
                  {user?.role === "admin" && (
                    <Link
                      to={`/clients/rates/add?uid=${client?.uid}`}
                      className="inline-flex items-center rounded border border-transparent bg-indigo-100 px-2.5 py-1.5 text-xs font-medium text-indigo-700 cursor-pointer hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Add
                    </Link>
                  )}
                  {user?.role === "admin" && (
                    <Link
                      to={`/clients/rates/edit?uid=${client?.uid}`}
                      className="ml-2 inline-flex items-center rounded border border-transparent bg-indigo-100 px-2.5 py-1.5 text-xs font-medium text-indigo-700 cursor-pointer hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Edit
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 px-0 align-middle inline-block min-w-full">
            <ul className="divide-y divide-gray-200">
              {!client?.rates && (
                <li className="py-2 px-6 flex flex-wrap items-center animate-pulse">
                  <div className="flex-1">
                    <div className="rounded-full bg-gray-200 w-44 h-5" />
                  </div>
                  <div className="flex-none flex justify-end text-lg font-medium text-green-700">
                    <div className="rounded-full bg-gray-200 w-12 h-6" />
                  </div>
                </li>
              )}

              {client?.rates.map((service, idx) => {
                const show = service.is_active;

                return show && parseFloat(service.rate) !== 0.0 ? (
                  <li
                    key={service.id}
                    className="py-2 px-6 flex flex-wrap items-center"
                  >
                    <div className="flex-1">
                      <span className="text-sm font-medium text-gray-500 uppercase truncate">
                        {RATE_TYPE_LABELS[service.rate_type]}
                      </span>
                    </div>
                    <div className="flex-none flex justify-end text-lg font-medium text-green-700">
                      {service.rate !== -1 ? (
                        <span className="mt-1 text-lg tracking-tight font-semibold text-gray-900">
                          {service.rate % 1 === 0
                            ? parseInt(service.rate)
                            : service.rate}
                          %
                        </span>
                      ) : (
                        <span className="mt-1 text-sm tracking-tight font-semibold text-gray-400">
                          N/A
                        </span>
                      )}
                    </div>
                  </li>
                ) : null;
              })}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Rates;
